<template>
  <div class="auth-layout min-h-screen bg-gradient-to-br from-pink-100 to-blue-100 flex items-center justify-center p-4">
    <div class="w-full max-w-md">
      <!-- Logo -->
      <div class="text-center mb-8">
        <div class="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full shadow-lg mb-4">
          <div class="w-16 h-16 bg-pink-500 rounded-full flex items-center justify-center">
            <span class="text-white font-bold text-3xl">P</span>
          </div>
        </div>
        <h1 class="text-3xl font-bold text-gray-800">Pasticceria</h1>
        <p class="text-gray-600 mt-2">Gestionale e E-commerce</p>
      </div>

      <!-- Auth Card -->
      <div class="bg-white rounded-2xl shadow-xl p-8">
        <slot />
      </div>

      <!-- Footer Links -->
      <div class="mt-8 text-center">
        <router-link 
          to="/" 
          class="text-gray-600 hover:text-pink-500 transition-colors"
        >
          ← Torna al sito
        </router-link>
      </div>

      <!-- Copyright -->
      <div class="mt-8 text-center text-sm text-gray-500">
        <p>&copy; 2024 Pasticceria. Tutti i diritti riservati.</p>
      </div>
    </div>

    <!-- Decorative Elements -->
    <div class="fixed top-10 left-10 w-20 h-20 bg-pink-200 rounded-full opacity-20 blur-xl"></div>
    <div class="fixed bottom-10 right-10 w-32 h-32 bg-blue-200 rounded-full opacity-20 blur-xl"></div>
    <div class="fixed top-1/2 right-20 w-24 h-24 bg-yellow-200 rounded-full opacity-20 blur-xl"></div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useAppStore } from '@/stores/app'

const appStore = useAppStore()

onMounted(() => {
  // Clear any existing notifications when entering auth pages
  appStore.clearNotifications()
})
</script>

<style scoped>
.auth-layout {
  animation: gradientAnimation 15s ease infinite;
  background-size: 200% 200%;
}

@keyframes gradientAnimation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
